export const ATTRIBUTE_CONDITIONS_MAPPER = {
    "maximum_retail_price": "Product MRP",
    "sale_price": "Product SP",
    "discount_percent": "Product Discount",
    "star_rating": "Product Star rating",
    "reviews": "Product Reviews",
    "name": "Product Name",
    "size": "Product - Size",
    "color": "Product - Color",
    "launch_date": "Launched Date",
    "gender":"Gender",
    "ad_status":"Products not advertised",
    "best_selling_rank":"BSR",
    "top_best_sellers_rank":"Top BSR",
    "cut_size_percent":"Cut Size *"
}

export const GENERAL_OPERATORS_MAPPER = {
    "EQUALS": "=",
    "NOT_EQUALS": "!=",
    "GREATER_THAN": ">",
    "LESS_THAN": "<",
    "GREATER_THAN_OR_EQUAL": ">=",
    "LESS_THAN_OR_EQUAL": "<=",
    "CONTAINS": "contains",
    "not contains": "NOT_CONTAINS",
}

export const PERFORMANCE_CONDTIONS_MAPPER = {
    "sale_value":"Revenue",
    "top_sale_value":"Top Selling",
    "top_conversion_rate":'Top Conversion',
    "top_roas":"Top ROAS",
    "quantity":"Available Inventory",
    "total_revenue":"Total Revenue",
    "tacos":"TACOS",
    "troas":"TROAS",
    "total_asp":"ASP",
    "total_units_sold":"Total Units Sold",
    "roas":"ROAS",
    "conversion_rate":"Conversion Rate",
    "ctr":"CTR"
}

export const PRODUCT_SET_DURATION_MAPPER = {
    "last_14_days":"14 days",
    "last_7_days":"7 days",
    "last_3_days":"3 days",
    "last_1_day":"1 day",
}
export const PRODUCT_SET_REFRESH_DURATION = { 
    "1_days":"1 Day",
    "3_days":"3 Days",
    "7_days":"7 Days",
    "14_days":"14 Days",
    "21_days":"21 Days",
}

export const STOP_LOSS_LOGS_DATAHEADS =  [
    {
      fieldName: "Impact",
      id: "impact",
      apiKey: "decision?.extraInfo?.product_count",
      minWidth: "152px",
    },
    {
      fieldName: "Ad Spend Saved",
      id: "ad_spend_saved",
      apiKey: "decision?.extraInfo?.adSpendSaved",
    },
    {
      fieldName: "Only Recommendation",
      id: "only_recommendation",
      apiKey: "decision?.decisionApplied",
      minWidth: "140px",
    },

    {
      fieldName: "Effective Status",
      id: "effective_status",
      apiKey: "effective_change",
    },
    {
      fieldName: "Activity Time",
      id: "activity_time",
      apiKey: "created_at",
    },
    {
      fieldName: "Exclusion Configuration",
      id: "exclusion_case",
      apiKey: "rule_config?.ruleTasks?.0?.entityMetricFilter?.cubeFilters",
      minWidth: "340px",
    },
    {
      fieldName: "Inclusion Configuration",
      id: "inclusion_case",
      apiKey: "rule_config?.ruleTasks?.1?.entityMetricFilter?.cubeFilters",
      minWidth: "340px",
    },
    {
      fieldName: "User",
      id: "user",
      apiKey: "rule_config?.modifiedBy",
    },
  ]

export const PRODUCT_SET_LOGS_DATAHEADS =  [
    {
      fieldName: "Impact",
      id: "impact",
      apiKey: "decision?.extraInfo?.product_count",
      minWidth: "152px",
      tooltip: "Number of products this rule affected in its last run.",
    },
    {
      fieldName: "Impact Type",
      id: "impact_type",
      apiKey: "decision?.extraInfo",
      minWidth: "180px",
      // Platform-specific multiline tooltip is rendered in StopLossLogsModal
    },
    {
      fieldName: "Campaign",
      id: "campaign_name",
      apiKey: "extra_info_json?.populated_entity_list",
      tooltip: "Product Set Added Linked to Campaign(s).",
    },

    {
      fieldName: "Adgroup ",
      id: "adset_name",
      apiKey: "extra_info_json?.populated_entity_list",
      tooltip: "Ad group(s) available within the campaign.",
    },
    {
      fieldName: "Last Run",
      id: "activity_time",
      apiKey: "created_at",
      tooltip: "The time this rule ran at.",
    },
    {
      fieldName: "Configuration",
      id: "configuration",
      apiKey: "product_set_config?.cubeFilters",
      minWidth: "340px",
      tooltip: "Filters applied to generate the product set.",
    },
    {
      fieldName: "User",
      id: "triggered_by",
      apiKey: "triggered_by",
      tooltip: "The user who created or edited this rule.",
    },
  ]

export const PRODUCT_SET_LIST_DATAHEADS = {
  amazon:[
    {
        "fieldName": "Status",
        "id": "status",
        "isDefaultHead": true,
        "isHeadRightAlign": false,
        "isHeadWithIcon": false,
        "isAbbrivation": false
    },
    {
        "fieldName": "Product Set",
        "id": "product_set",
        "isDefaultHead": true,
        "isHeadRightAlign": false,
        "isHeadWithIcon": false,
        "isAbbrivation": false
    },
    {
        "fieldName": "Created At",
        "id": "created_at",
        "isHeadRightAlign": false,
        "isHeadWithIcon": "sort",
        "isAbbrivation": false,
        "type": "datetime",
    },
    {
        "fieldName": "Refresh Frequency",
        "id": "refresh_frequency",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": false,
        "isAbbrivation": false,
        "isFindTaskActive": false,
        "status": false,
        "isSortFunctionalityNeededHere": true
  
    },
    {
        "fieldName": "Spends",
        "id": "spends",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        isCurrencyFormat: true,
    },
     {
        fieldName: "Impressions",
        id: "impressions",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: false,
        type: "number",


      },    {
        fieldName: "Clicks",
        id: "clicks",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: false,
        type: "number",

      }
   ,{
        fieldName: "CPM",
        id: "cpm",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "number",

      },
      {
        fieldName: "CTR",
        id: "ctr",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "percent",
      },
      {
        fieldName: "CPC",
        id: "cpc",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "number",
      },
      {
        fieldName: "CVR",
        id: "cvr",
        status: false,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        isHeadRightAlign: true,
        type: "percent",
      },
      {
        fieldName: "AOV",
        id: "aov",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "number",
      }, {
        fieldName: "ACOS",
        id: "acos",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "number",
      },
      {
        "fieldName": "Total Units",
        "id": "orders",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        type: "number",
    },
    {
        "fieldName": "Revenue",
        "id": "sale_value",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        isCurrencyFormat: true,
    },
    {
        "fieldName": "ROAS",
        "id": "roas",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        type: "number",
    }
  ],
  myntra:[
    {
        "fieldName": "Status",
        "id": "status",
        "isDefaultHead": true,
        "isHeadRightAlign": false,
        "isHeadWithIcon": false,
        "isAbbrivation": false
    },
    {
        "fieldName": "Product Set",
        "id": "product_set",
        "isDefaultHead": true,
        "isHeadRightAlign": false,
        "isHeadWithIcon": false,
        "isAbbrivation": false
    },
    {
        "fieldName": "Created At",
        "id": "created_at",
        "isHeadRightAlign": false,
        "isHeadWithIcon": "sort",
        "isAbbrivation": false,
        "type": "datetime",
    },
    {
        "fieldName": "Refresh Frequency",
        "id": "refresh_frequency",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": false,
        "isAbbrivation": false,
        "isFindTaskActive": false,
        "status": false,
        "isSortFunctionalityNeededHere": true
  
    },
    {
        "fieldName": "Spends",
        "id": "spends",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        isCurrencyFormat: true,
  
    },
    {
        "fieldName": "Impressions",
        "id": "impressions",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        type: "number",
  
    },
    {
        "fieldName": "Views",
        "id": "views",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        type: "number",

  
    },
    {
        "fieldName": "Clicks",
        "id": "clicks",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        type: "number",
    },
    {
        fieldName: "CTR",
        id: "ctr",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "percent",
      },    {
        fieldName: "CPC",
        id: "cpc",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "number",
      },{
        fieldName: "CVR",
        id: "cvr",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "percent",
      },
      {
        fieldName: "Total Units",
        id: "orders",
        status: false,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        isHeadRightAlign: true,
        type: "number",
      }
      ,{
        fieldName: "Total Revenue",
        id: "revenue",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        isCurrencyFormat: true,
      }
      ,{
        fieldName: "Total ROAS",
        id: "roas",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "number",
      }
  ],
  flipkart:[
    {
        "fieldName": "Status",
        "id": "status",
        "isDefaultHead": true,
        "isHeadRightAlign": false,
        "isHeadWithIcon": false,
        "isAbbrivation": false
    },
    {
        "fieldName": "Product Set",
        "id": "product_set",
        "isDefaultHead": true,
        "isHeadRightAlign": false,
        "isHeadWithIcon": false,
        "isAbbrivation": false
    },
    {
        "fieldName": "Created At",
        "id": "created_at",
        "isHeadRightAlign": false,
        "isHeadWithIcon": "sort",
        "isAbbrivation": false,
        "type": "datetime",
    },
    {
        "fieldName": "Refresh Frequency",
        "id": "refresh_frequency",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": false,
        "isAbbrivation": false,
        "isFindTaskActive": false,
        "status": false,
        "isSortFunctionalityNeededHere": true
  
    },
    {
        "fieldName": "Spends",
        "id": "spends",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        isCurrencyFormat: true,
  
    },
    {
        "fieldName": "Impressions",
        "id": "impressions",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        type: "number",
  
    },
    {
        "fieldName": "Views",
        "id": "views",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        type: "number",
  
    },
    {
        "fieldName": "Clicks",
        "id": "clicks",
        // "isDefaultHead": true,
        "isHeadRightAlign": true,
        "isHeadWithIcon": "sort",
        "isAbbrivation": true,
        "isSortFunctionalityNeededHere": true,
        type: "number",
    },
    {
        fieldName: "CTR",
        id: "ctr",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "percent",
      },    {
        fieldName: "CPC",
        id: "cpc",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "number",
      },{
        fieldName: "CVR",
        id: "cvr",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "percent",
      },
      {
        fieldName: "Total Units",
        id: "orders",
        status: false,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        isHeadRightAlign: true,
        type: "number",
      }
      ,{
        fieldName: "Total Revenue",
        id: "revenue",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        isCurrencyFormat: true,

      }
      ,{
        fieldName: "Total ROAS",
        id: "roas",
        status: false,
        isHeadRightAlign: true,
        isHeadWithIcon: "sort",
        isAbbrivation: true,
        type: "number",
      }
  ]
}
